var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#45B184"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 16,
    height: 16,
    rx: 8,
    stroke: "#45B184"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4443 5.6123C12.5439 5.61232 12.6425 5.63236 12.7344 5.6709C12.8259 5.70937 12.9089 5.7661 12.9785 5.83691H12.9795C13.2671 6.12791 13.2725 6.59452 12.9961 6.89355L8.5625 12.1367L8.55762 12.1426C8.48898 12.2179 8.40532 12.2783 8.3125 12.3203C8.21975 12.3623 8.11938 12.3848 8.01758 12.3867C7.91562 12.3886 7.81413 12.3696 7.71973 12.3311C7.62532 12.2925 7.53922 12.2349 7.46777 12.1621V12.1611L4.76953 9.42871V9.42773C4.62893 9.28427 4.54985 9.09151 4.5498 8.89062C4.5498 8.68962 4.6288 8.49606 4.76953 8.35254C4.83929 8.28141 4.9228 8.22511 5.01465 8.18652C5.10648 8.14795 5.20508 8.12797 5.30469 8.12793C5.40442 8.12793 5.50376 8.1479 5.5957 8.18652C5.68753 8.22514 5.77109 8.2814 5.84082 8.35254H5.83984L7.97461 10.5156L11.8838 5.86523L11.9121 5.83398C11.9812 5.76437 12.0638 5.7089 12.1543 5.6709C12.2461 5.63239 12.3448 5.6123 12.4443 5.6123Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCheck);
export default __webpack_public_path__ + "static/media/profileCheck.49e884a0b1e6afcf417ec80dd0017bce.svg";
export { ForwardRef as ReactComponent };